// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"466b6145","852":"00f8f4ab"}[chunkId] + ".chunk.css";
};